import { get } from '$fetch'

/**
 * 获取车辆质检报告
 * @param {String} cid 车源id
 */
export const detailReport = (params = {}) => get('/lurker/v1/detail/car/test/report', params, { isLoading: false })


/**
 * 获取车辆质检报告
 * @param {String} cid 车源id
 */
export const detailReportQrcode = (params = {}) => get('/api/qrcode/generate', params, { isLoading: false })
